export const filterSwitchTree = (switchTree) =>
  Object.fromEntries(
    Object.entries(switchTree || {})
      .map(([locationId, location]) => {
        if (!location?.isSpecificLocation) {
          if (!location?.devices) return null;

          if (Object.keys(location.devices).length > 0) {
            return [locationId, location];
          }

          return null;
        }

        const filteredSubLocations = Object.fromEntries(
          Object.entries(location.subLocations || {})
            .map(([subId, subLocation]) => {
              if (!subLocation?.devices) return null;

              if (Object.keys(subLocation.devices).length > 0) {
                return [subId, subLocation];
              }

              return null;
            })
            .filter(Boolean),
        );

        if (Object.keys(filteredSubLocations).length > 0) {
          return [
            locationId,
            { ...location, subLocations: filteredSubLocations },
          ];
        }

        return null;
      })
      .filter(Boolean),
  );

export const countSwitchTreeDevices = (switchTree) =>
  Object.values(switchTree || {}).reduce((total, location) => {
    if (location?.isSpecificLocation) {
      return (
        total +
        Object.values(location.subLocations || {}).reduce(
          (subTotal, subLocation) =>
            subTotal + Object.keys(subLocation.devices || {}).length,
          0,
        )
      );
    }
    return total + Object.keys(location?.devices || {}).length;
  }, 0);
